module.exports = "/images/run-better-promotions.svg?11ae55fab608be1b4a8f1670753d1169";